var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-basketball",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    cx: 17,
    cy: 17,
    r: 16
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    x1: 17,
    y1: 1.4,
    x2: 17,
    y2: 32.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M8.2,3.8c4.3,1.1,10,4.1,1.6,12.6C2.5,23.9,7.1,28.2,7.9,30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M25.8,3.8c-4.3,1.1-10,4.1-1.6,12.6c7.3,7.4,2.7,11.8,1.9,13.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M1.2,17.7c0,0,3.3-11.1,15.8-11.1s15.8,11.1,15.8,11.1"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-computer",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.9,25.6C32,25.6,32,25.6,31.9,25.6c0.1,1.5-1,2.6-2.4,2.6h-25c-1.4,0-2.5-1.1-2.5-2.5 c0,0,0-0.1,0.1-0.1H31.9 M31.9,24.6H2.1c-0.6,0-1.1,0.5-1.1,1.1c0,1.9,1.6,3.5,3.5,3.5h25c1.9,0,3.5-1.6,3.5-3.5 C33,25.1,32.5,24.6,31.9,24.6L31.9,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.7,25.5V26 c0,0.2-0.5,0.4-1.1,0.4h-5.2c-0.6,0-1.1-0.2-1.1-0.4v-0.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M30.7,24.6V7.4 c0-1.4-1.1-2.6-2.6-2.6h-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M3.3,24.6V7.4 c0-1.4,1.1-2.6,2.6-2.6h1h16.6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M16.5,6.7h10.8 c0.7,0,1.2,0.6,1.2,1.2v13.5c0,0.7-0.5,1.2-1.2,1.2H6.7c-0.7,0-1.2-0.6-1.2-1.2V8c0-0.7,0.5-1.2,1.2-1.2h5.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 14.1,11.7 11.4,15.2 14.1,18.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 19.8,11.7 22.5,15.2 19.8,18.2"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 17.5,
    y1: 11.7,
    x2: 15.7,
    y2: 18.2
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-diy",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.8,11.3c0.1,0,0.2,0,0.3,0.1l2.7,2.7c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3l-0.4,0.4 c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1l-2.7-2.7c-0.2-0.2-0.2-0.4,0-0.6l0.4-0.4C2.6,11.3,2.7,11.3,2.8,11.3 M2.8,10.3 c-0.4,0-0.7,0.1-1,0.4l-0.4,0.4c-0.6,0.6-0.6,1.5,0,2l2.7,2.7c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4l0.4-0.4 c0.6-0.6,0.6-1.5,0-2l-2.7-2.7C3.5,10.4,3.1,10.3,2.8,10.3L2.8,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.2,11.2l19.5,17.4c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1l-2.3,2.3c0,0-0.1,0-0.1,0s-0.1,0-0.1,0l-18-18.9 L12.2,11.2 M12.1,9.9l-2.4,2.4l18.7,19.6c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3l2.3-2.3c0.4-0.4,0.4-1.2,0-1.6L12.1,9.9 L12.1,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5,2.7c0.4,0,0.8,0.1,1.2,0.2c-0.5,0.3-1.1,0.7-1.7,1.2c-1.4,1.4-1,2.8-0.7,3.6c0,0.2,0.1,0.4,0.1,0.5 L8.5,12c0,0-0.1,0-0.1,0s-0.1,0-0.1,0L5.2,8.9c-0.1-0.1-0.1-0.2,0-0.2L9,4.8C9.2,4.6,11.2,2.7,13.5,2.7 M13.5,1.7 c-2.6,0-4.8,2.1-5.1,2.4L4.5,8C4,8.4,4,9.2,4.5,9.6l3.1,3.1c0.2,0.2,0.5,0.3,0.8,0.3S9,13,9.2,12.8l3.8-3.8 C14,8,11.9,6.5,13.6,4.8c1.4-1.4,2.8-1.5,3.3-1.5c0.1,0,0.2,0,0.2,0C15.9,2.1,14.6,1.7,13.5,1.7L13.5,1.7z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 4.1,
    y1: 11,
    x2: 4.9,
    y2: 10.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 6.5,
    y1: 13.4,
    x2: 7.3,
    y2: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 19.6,
    y1: 21.4,
    x2: 21.4,
    y2: 19.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 21.3,
    y1: 23,
    x2: 23,
    y2: 21.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 18.5,
    y1: 15.1,
    x2: 22.8,
    y2: 10.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 11,
    y1: 22.7,
    x2: 15.3,
    y2: 18.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.1,25.7l1.7,0.5l0.5,1.7L7,29.2l-1.7-0.5L4.8,27L6.1,25.7 M5.8,24.6l-2.1,2.1l0.8,2.9l2.9,0.8l2.1-2.1 l-0.8-2.9L5.8,24.6L5.8,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M12.5,17.8 l-4.4,4.4c-1.9-0.6-4-0.1-5.5,1.4c-2.1,2.1-2.1,5.6,0,7.8s5.6,2.1,7.8,0c1.5-1.5,1.9-3.6,1.4-5.5l4.4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M17.8,12.6l4.4-4.4 c-0.6-1.9-0.1-4,1.4-5.5C25,1.2,27.1,0.7,29,1.3c-1.3,1.3-3.8,3.8-3.8,3.8l-0.2,1.8l1.8,1.8l2.3-0.1c0,0,1.9-1.7,3.6-3.5 c0.6,1.9,0,3.8-1.5,5.3c-1.5,1.5-3.6,1.9-5.5,1.4l-4.4,4.4"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-football",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8287 8.76834C27.7444 8.1858 27.3077 7.71289 26.7156 7.56337C24.1212 6.90866 21.4349 6.82279 18.9476 7.31519C17.6751 7.56703 16.4511 7.96899 15.3095 8.5095C14.134 9.06616 13.0402 9.77294 12.0584 10.6104C11.0765 11.4478 10.2163 12.4073 9.50165 13.4628C8.80756 14.4875 8.24722 15.6075 7.83584 16.7917C7.38928 18.078 7.1183 19.4462 7.03082 20.8576C6.96173 21.9743 7.00895 23.1095 7.17091 24.232C7.25521 24.8145 7.69195 25.2874 8.28398 25.4366C10.8787 26.0913 13.5647 26.1772 16.0521 25.6848C17.3245 25.433 18.5485 25.031 19.6901 24.4905C20.8657 23.9338 21.9594 23.2271 22.9413 22.3896C23.9231 21.5522 24.7833 20.5927 25.498 19.5372C26.1921 18.5122 26.7524 17.3922 27.1638 16.2083C27.6107 14.922 27.8816 13.5541 27.9691 12.1427C28.0382 11.0257 27.9913 9.89048 27.829 8.76804L27.8287 8.76834ZM13.1952 25.256C12.2175 24.4439 11.2711 23.5468 10.3748 22.5769C9.47851 21.607 8.66399 20.5979 7.94074 19.5689C8.0634 18.7601 8.25102 17.972 8.50235 17.2132C9.37868 18.6587 10.4572 20.0872 11.7072 21.4405C12.9575 22.7937 14.3057 23.9923 15.6958 24.9996C14.8803 25.1498 14.043 25.235 13.1949 25.256H13.1952ZM19.9171 11.1874C19.8176 11.2581 19.718 11.3287 19.6179 11.3975L19.024 11.8178C18.9688 11.857 18.9143 11.8963 18.8595 11.9356C18.8867 11.9691 18.9137 12.0029 18.94 12.037C19.1295 12.2825 19.3 12.5413 19.4458 12.8181C19.5187 12.9563 19.5849 13.0995 19.6429 13.2484C19.6715 13.3233 19.699 13.3988 19.7225 13.4771C19.7466 13.555 19.7681 13.6348 19.7827 13.7195C19.7025 13.6814 19.6293 13.6385 19.5586 13.5937C19.4876 13.5492 19.4204 13.502 19.3542 13.4542C19.223 13.3577 19.0997 13.2551 18.9831 13.1479C18.7498 12.9335 18.5416 12.7015 18.3524 12.456C18.3273 12.4234 18.3026 12.3903 18.2779 12.3571C18.1365 12.4606 17.9958 12.5644 17.856 12.6695C17.716 12.7742 17.5768 12.8799 17.438 12.9859C17.5939 13.1817 17.7375 13.3872 17.8643 13.6059C17.9419 13.739 18.0129 13.8775 18.076 14.0218C18.1071 14.0946 18.1372 14.1677 18.1635 14.2441C18.1901 14.3203 18.2145 14.3979 18.2322 14.4811C18.1511 14.4473 18.077 14.4083 18.005 14.3675C17.9327 14.327 17.8643 14.2834 17.7968 14.2393C17.6627 14.1501 17.5366 14.0547 17.4171 13.9542C17.2206 13.7895 17.0406 13.6123 16.8735 13.4247C16.5401 13.6881 16.2108 13.9558 15.886 14.2283C16.0394 14.4068 16.1814 14.5943 16.31 14.7941C16.3937 14.9238 16.4707 15.0587 16.5405 15.2003C16.5747 15.2716 16.6083 15.3434 16.6381 15.4184C16.6682 15.493 16.6961 15.5697 16.7176 15.6519C16.6352 15.6218 16.5595 15.5861 16.4856 15.5484C16.4115 15.5112 16.3411 15.4707 16.2717 15.4296C16.1338 15.3465 16.0032 15.2567 15.8793 15.1617C15.6882 15.0155 15.5114 14.8577 15.3453 14.6903C15.0255 14.968 14.7098 15.2506 14.398 15.5374C14.5717 15.7189 14.7333 15.9117 14.88 16.1181C14.9697 16.2442 15.0531 16.3758 15.1295 16.5143C15.1672 16.584 15.2039 16.6544 15.2372 16.7284C15.2708 16.8018 15.3025 16.8773 15.3275 16.9586C15.2436 16.9321 15.1662 16.8995 15.0908 16.8651C15.015 16.831 14.9428 16.7936 14.8715 16.7555C14.7298 16.6781 14.5951 16.5941 14.4667 16.5043C14.2563 16.3575 14.0608 16.1964 13.8772 16.0246C13.7511 16.1443 13.6253 16.2646 13.5007 16.3861C13.3759 16.507 13.2516 16.6291 13.128 16.7515C13.1591 16.7786 13.1901 16.806 13.2206 16.8334C13.4519 17.0433 13.6671 17.2692 13.8608 17.5171C13.9577 17.641 14.049 17.7707 14.1333 17.9075C14.1749 17.9763 14.2157 18.046 14.2534 18.1191C14.2912 18.1919 14.327 18.2668 14.3568 18.3478C14.2709 18.324 14.191 18.2939 14.1134 18.2616C14.0351 18.23 13.9606 18.1946 13.8864 18.1587C13.7394 18.0856 13.5993 18.0055 13.4652 17.9197C13.1965 17.7479 12.9493 17.5545 12.7182 17.3444C12.6862 17.3155 12.6548 17.286 12.6235 17.2561C12.5762 17.3036 12.5293 17.3511 12.4821 17.3989L11.9772 17.9157C11.8942 18.0031 11.8096 18.0896 11.7243 18.1761C11.64 18.2631 11.5557 18.3505 11.4682 18.4358C11.5227 18.3283 11.5804 18.2226 11.6381 18.1167C11.698 18.0122 11.7582 17.9078 11.8203 17.8042C11.8828 17.701 11.9477 17.5993 12.0118 17.497L12.2121 17.1946C12.2596 17.1249 12.3081 17.0554 12.3569 16.9866C12.2599 16.8819 12.1671 16.7735 12.0783 16.6602C11.9813 16.5362 11.8901 16.4065 11.8058 16.2698C11.7639 16.201 11.723 16.1312 11.6856 16.0585C11.6476 15.9857 11.6118 15.9111 11.582 15.8304C11.6676 15.8544 11.7474 15.8846 11.8251 15.9169C11.9031 15.9488 11.9779 15.9838 12.0517 16.0201C12.1984 16.0932 12.3385 16.1733 12.4729 16.2591C12.5693 16.3206 12.6628 16.3852 12.754 16.4522C12.8634 16.3112 12.9756 16.172 13.0897 16.0347C13.2126 15.8873 13.3381 15.7421 13.4665 15.5986C13.3584 15.4741 13.2554 15.3447 13.1594 15.2092C13.0697 15.0831 12.9863 14.9515 12.91 14.813C12.8722 14.7432 12.8355 14.6729 12.8019 14.5992C12.7683 14.5258 12.7366 14.4506 12.7112 14.3696C12.7949 14.3964 12.8722 14.429 12.9477 14.4637C13.0234 14.4978 13.0954 14.5353 13.1667 14.5736C13.3084 14.651 13.4427 14.7353 13.5714 14.8249C13.6963 14.9119 13.8158 15.0039 13.9308 15.0998C14.2395 14.781 14.5612 14.4738 14.8946 14.1787C14.803 14.0611 14.7165 13.9396 14.6354 13.8133C14.5517 13.6835 14.4747 13.5486 14.4049 13.4073C14.3704 13.3364 14.3371 13.2642 14.3073 13.1893C14.2772 13.1147 14.249 13.0383 14.2275 12.956C14.3099 12.9862 14.3853 13.0221 14.4591 13.0599C14.533 13.0973 14.6033 13.1378 14.6728 13.1789C14.8106 13.2624 14.9409 13.3519 15.0651 13.4469C15.1862 13.5395 15.3016 13.6366 15.4122 13.738C15.757 13.4555 16.1129 13.185 16.4786 12.9283C16.3928 12.8071 16.3116 12.682 16.2365 12.5523C16.1589 12.4189 16.0879 12.2806 16.0248 12.1363C15.9937 12.0638 15.9636 11.9904 15.937 11.9143C15.9104 11.8385 15.8857 11.7608 15.8679 11.6777C15.9487 11.7115 16.0229 11.7508 16.0945 11.7916C16.1668 11.8321 16.2352 11.8756 16.3024 11.9201C16.4365 12.0093 16.5626 12.1046 16.6821 12.2051C16.8111 12.3132 16.9328 12.4268 17.0488 12.5449C17.212 12.4396 17.3772 12.337 17.5439 12.2374C17.6995 12.1448 17.8567 12.0544 18.0151 11.9667C17.9565 11.8714 17.9011 11.7742 17.8484 11.6746C17.7755 11.5364 17.7093 11.3933 17.6513 11.2447C17.6228 11.1701 17.5952 11.0945 17.5714 11.0163C17.5474 10.9383 17.5255 10.8588 17.5109 10.7742C17.5908 10.8123 17.6637 10.8555 17.7343 10.9003C17.8053 10.9447 17.8725 10.9919 17.9388 11.04C18.07 11.1366 18.1933 11.2392 18.3096 11.3464C18.4164 11.4444 18.5178 11.5464 18.6145 11.6515C18.6915 11.6131 18.7688 11.5751 18.8465 11.5379C18.9587 11.4861 19.0702 11.4335 19.1827 11.3826C19.2962 11.3336 19.409 11.2836 19.5231 11.2361C19.6375 11.1892 19.7526 11.1442 19.8676 11.0991C19.9839 11.0565 20.0999 11.0138 20.2175 10.9746C20.1186 11.0479 20.0185 11.1177 19.9187 11.1877L19.9171 11.1874ZM26.4976 15.7871C25.6213 14.3416 24.5427 12.9131 23.2927 11.5598C22.0424 10.2066 20.6942 9.008 19.3041 8.00066C20.1199 7.85053 20.9569 7.76527 21.8051 7.74426C22.7828 8.5564 23.7292 9.4535 24.6255 10.4234C25.5217 11.3933 26.3363 12.4024 27.0595 13.4317C26.9369 14.2405 26.7492 15.0286 26.4979 15.7871H26.4976Z",
    fill: "currentColor"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-golf",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.3,26.9 c0,0,0-23.4,0-24.6c4.9-4.1,9.1,4.5,14.4,0.4c0,3,0,7.3,0,9.3c-4.9,4.4-9.9-4.5-14.4-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.3,26.3c0.8,0,1.2,0.3,1.3,0.4c0,0.1-0.5,0.5-1.3,0.5S8,26.8,8,26.7C8,26.6,8.5,26.3,9.3,26.3 M9.3,25.3 C8,25.3,7,25.9,7,26.7s1,1.4,2.3,1.4c1.3,0,2.3-0.6,2.3-1.4S10.5,25.3,9.3,25.3L9.3,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.1,27.4c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7S22.7,27.4,23.1,27.4  M23.1,26.4c-0.9,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7S24,26.4,23.1,26.4L23.1,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.9,21.3c3.6,0,5.5,0.4,6.3,0.7c-0.1,0-0.1,0-0.2,0.1c-0.9,0.3-2.4,0.8-2.4,2.5c0,1.9,2.1,2.7,4.1,3.5 c1.4,0.5,3.1,1.2,3.3,2c-0.8,0.7-5.7,1.9-13.4,1.9c-9.7,0-16.5-2-16.5-4.8C2,23.6,11.8,21.3,20.9,21.3 M20.9,20.3 c-8.2,0-19.9,2-19.9,6.8c0,4.2,9.1,5.8,17.5,5.8c7.5,0,14.5-1.2,14.5-2.8c0-2.9-7.4-3.1-7.4-5.6c0-1.8,3.1-1.3,3.1-2.6 C28.7,20.8,25.3,20.3,20.9,20.3L20.9,20.3z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-movies",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 1,
    y1: 32.7,
    x2: 33,
    y2: 32.7
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "13.5,18.6 12.8,32.7 4.7,32.7  4,18.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M13.3,16.3h-9 c-0.2,0-0.4,0.1-0.5,0.3l-0.5,1.6c-0.1,0.3,0.1,0.6,0.5,0.6h10c0.3,0,0.6-0.3,0.5-0.6l-0.5-1.6C13.7,16.4,13.5,16.3,13.3,16.3z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "5.8,11.1  8.1,12.2 8.7,16.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M28.8,30.5 c1.5-1.4,2.6-3.3,2.8-5.5c0-0.4-0.3-0.8-0.7-0.8H15.8c-0.4,0-0.8,0.4-0.7,0.8c0.4,4.2,3.9,7.5,8.3,7.6c0,0,0.1,0,0.1,0l2-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.6,24.1h7.9v-2 c0,0-0.4-1.1-1.8-0.8c-0.4-1.3-2.3-1.7-2.9-0.6c-0.4-0.4-1.1-0.8-1.1-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M24.1,24.1h-8.8v-2 c0,0,0.4-1.1,1.8-0.8c0.4-1.3,2.3-1.7,2.9-0.6c0.4-0.4,1.1-0.8,1.1-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M22.2,18.4 c0-1.3,2.1-1.8,2.3-0.1c1.1,0.1,2,1.2,0.4,2.2c-0.1,1.2-2.4,1.3-2.7,0.3C21,20.9,20.4,18.6,22.2,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M25.2,29.6 c0-1.3,2.1-1.8,2.3-0.1c1.1,0.1,2,1.2,0.4,2.2c-0.1,1.2-2.4,1.3-2.7,0.3C24,32,23.3,29.7,25.2,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M27.4,14.3 c0-1.3,2.1-1.8,2.3-0.1c1.1,0.1,2,1.2,0.4,2.2c-0.1,1.2-2.4,1.3-2.7,0.3C26.2,16.8,25.5,14.4,27.4,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.5,20.8h2.8 c0.4,0,0.7-0.3,0.7-0.7V2c0-0.4-0.3-0.7-0.7-0.7h-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M4.1,20.8H1.7 c-0.4,0-0.7-0.3-0.7-0.7V2c0-0.4,0.3-0.7,0.7-0.7h20.4"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 13.2,
    y1: 20.8,
    x2: 17.1,
    y2: 20.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 16.9,
    cy: 10,
    r: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.9,8.9v2.5 c0,0.2,0.2,0.3,0.4,0.2l2.3-1.3c0.2-0.1,0.2-0.3,0-0.4l-2.3-1.2C16.1,8.6,15.9,8.7,15.9,8.9z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sneakers",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M0.8,25.4 c0.1,0.4,0.4,0.8,0.8,0.8c1.4,0.2,4.9,0.5,11.8,0.5c9.4,0,10.3,0,10.3,0s6,0.5,9.3-2.6c1.2-1,0-2.1,0-2.1s0-2.4-3.5-2.2 c-3.5,0.3-12.3-3.9-13-5.1c-0.6-1.2-2.1-7.1-3-7.5C12.6,6.9,8.9,8.7,7.6,9c-1.3,0.3-4,0.1-4.8,0.8s-1,3-1.4,6 C0.7,17.4,0.2,21.8,0.8,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1.9,12.9c2.1-1.2,8.6-3.6,9.7-4 c0.9-0.3,1.8-0.2,2.2,0.7c0.1,0.2,0,0.5-0.2,0.6c-1,0.4-1.1,1.2,0.2,1.4c0.1,0,0.3,0.1,0.3,0.3c0,0.2,0.1,0.4-0.1,0.4 c-1.4,0.7-6.5,2.3-6.3,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M0.6,22.5 C7.8,23.4,24.5,26,33,22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M12.5,13.1 c0,0.8-0.4,3,1.9,2.9s3,1.7,3.6,1.9c0.6,0.3,6.4,2.9,6.4,2.9l0.4-1.7c0,0-1.2,4.2,1,2.9c2.1-1.2,1.9-0.9,2.7-0.9 c0.8,0,2.3-0.8,2.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M24.3,20.8 c-0.4,0.9-1.2,2.2-1.2,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M2,15.3 c1.2,0.4,5.4,2.8,10.5-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1.3,17.1 c4,1.4,6.2,1.6,7.7,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.4,16.2c4.2,1.4,9.5,2.9,11.1,3.3c1.6,0.4,2.4-0.5,1.7-2.2c2.4,1,2.8,2.6,2.3,3.5 C16,21.7,14,21.4,12.4,21S1,17,1,17L1.4,16.2z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 14,
    y1: 14.3,
    x2: 15.6,
    y2: 12.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 16.5,
    y1: 14.8,
    x2: 15.7,
    y2: 15.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 18.6,
    y1: 16.3,
    x2: 17.6,
    y2: 17.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M21.2,17.8L20,19 c0.3,1.6,0.1,2.9-0.8,5.1"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23,
    y1: 18.3,
    x2: 21.9,
    y2: 19.6
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-drums",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 17.1,
    cy: 20.6,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 18.7,
    cy: 21.5,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 22.1,
    y1: 29.2,
    x2: 20.9,
    y2: 27.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 29.2,
    x2: 13.2,
    y2: 27.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M21.2,14.1L21,12.8 c-0.1-0.4,0.2-0.8,0.6-0.9l6.9-1.1c0.4-0.1,0.8,0.2,0.9,0.6l0.3,2c0.1,0.4-0.2,0.8-0.6,0.9l-6.4,1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9559 -0.2936 0.2936 0.9559 -0.5924 8.3538)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 27.5,
    cy: 6.2,
    rx: 6.1,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27.5,
    y1: 10.8,
    x2: 27.5,
    y2: 7.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27.5,
    y1: 30,
    x2: 27.5,
    y2: 14.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.2,
    y1: 28.4,
    x2: 27.5,
    y2: 25.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 32.1,
    y1: 28.4,
    x2: 27.8,
    y2: 25.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M12.8,14.1l0.2-1.3 c0.1-0.4-0.2-0.8-0.6-0.9l-6.9-1.1C5,10.7,4.6,11,4.6,11.4l-0.3,2c-0.1,0.4,0.2,0.8,0.6,0.9l6.4,1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2936 -0.9559 0.9559 0.2936 -1.312 10.5254)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 6.5,
    cy: 6.2,
    rx: 1.2,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 6.5,
    y1: 10.8,
    x2: 6.5,
    y2: 7.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 6.5,
    y1: 30,
    x2: 6.5,
    y2: 14.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10.8,
    y1: 28.4,
    x2: 6.5,
    y2: 25.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 1.9,
    y1: 28.4,
    x2: 6.2,
    y2: 25.1
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bat",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.6537 11C22.6537 11 22.5348 12.1759 21.8148 12.9087C21.2652 13.4674 20.6871 13.5112 19.9301 13.6258C19.4891 13.6929 18.5398 13.8053 18.3006 13.5883C18.1896 13.4878 18.1601 12.5889 18.1498 12.2739C18.14 11.9446 18.0862 11.4878 18.0178 11.4173C17.9827 11.563 17.9012 11.966 17.8732 12.065C17.8451 12.164 17.7182 12.6322 17.6953 12.7131C17.2295 12.6281 16.7525 12.6281 16.2867 12.7131C16.2651 12.6337 16.1383 12.1668 16.1102 12.0679C16.0821 11.9689 16.0006 11.5658 15.9655 11.4202C15.8976 11.4892 15.8433 11.946 15.8335 12.2768C15.8237 12.5942 15.7942 13.4907 15.6828 13.5911C15.4436 13.8081 14.4947 13.6958 14.0537 13.6287C13.2972 13.5112 12.7191 13.4674 12.1713 12.9087C11.449 12.1759 11.3287 11 11.3287 11H0C0 11 3.25443 12.0821 4.56519 14.264C5.34041 15.5541 5.22712 17.0473 5.02957 17.8202C7.95819 17.6622 10.3672 17.6622 12.7799 18.5459C16.0208 19.7322 16.6747 22.1715 16.9931 23C17.31 22.1715 17.9644 19.7322 21.2062 18.5459C23.619 17.6626 26.028 17.6612 28.9566 17.8202C28.7595 17.0473 28.6462 15.5541 29.4214 14.264C30.7294 12.0821 33.9861 11 33.9861 11H22.6537Z",
    fill: "currentColor"
  })))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-code",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4589 25.9815L13.1715 25.3246C12.9316 25.2578 12.7966 25.0092 12.8641 24.7716L17.9824 7.3215C18.0499 7.08398 18.3011 6.95037 18.5411 7.01718L20.8285 7.67406C21.0684 7.74086 21.2034 7.98952 21.1359 8.22703L16.0176 25.6772C15.9463 25.9147 15.6989 26.052 15.4589 25.9815ZM11.1842 21.8175L12.8153 20.0955C12.9878 19.9137 12.9766 19.6242 12.7853 19.4572L9.38809 16.4993L12.7853 13.5415C12.9766 13.3745 12.9916 13.085 12.8153 12.9032L11.1842 11.1812C11.0155 11.003 10.7305 10.9919 10.5468 11.1626L5.14343 16.1727C4.95219 16.3472 4.95219 16.6478 5.14343 16.8222L10.5468 21.8361C10.7305 22.0068 11.0155 21.9994 11.1842 21.8175ZM23.4532 21.8398L28.8566 16.8259C29.0478 16.6515 29.0478 16.3509 28.8566 16.1765L23.4532 11.1589C23.2733 10.9919 22.9883 10.9993 22.8158 11.1774L21.1847 12.8995C21.0122 13.0813 21.0234 13.3708 21.2147 13.5378L24.6119 16.4993L21.2147 19.4572C21.0234 19.6242 21.0084 19.9137 21.1847 20.0955L22.8158 21.8175C22.9845 21.9994 23.2695 22.0068 23.4532 21.8398Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-caret",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "32 9.06 17.88 24.94 2 9.06",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSprite);
export default __webpack_public_path__ + "static/media/iconSprite.cd999a2b6a1156e54c7abfae4c1aeeed.svg";
export { ForwardRef as ReactComponent };